export default __webpack_public_path__ + "static/media/PricingChartFullService.668ed877.png";